<template>
	<div class="fz-12" style="line-height: 18px">
		<p>{{ row.operator_name }}</p>
		<p class="color-gy-7">{{ row.add_time | formatDateTime }}</p>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	components: {},
	computed: {},
};
</script>

<style lang="less">
.placeholderInstitution {
	background: @color-b2;
	border-radius: 100px;
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>